module.exports = "https://coursera_assets.s3.amazonaws.com/images/4d4113700d88d1a1f04f4218851a0dd7.jpg";